const routes = [
  // 登录页
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login')
  },
  // 注册页
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/login/register')
  },
  // 联盟用户协议
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: () => import('@/views/login/userAgreement')
  },
  // 忘记密码页
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/login/forgetPassword')
  },
  // 默认首页入口页
  {
    path: '/',
    // name: 'layout',
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home')
      }
    ]
  },

  // 门户端基础布局
  {
    path: '/layout',
    name: 'layout',
    component: () => import('@/views/layout'),
    children: [
      // 首页
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
      },
      // 站内搜索页
      {
        path: '/standSearch',
        name: 'standSearch',
        component: () => import('@/views/search/standSearch'),
        meta: { title: '站内搜索' }
      },
      // 报名记录页
      {
        path: '/registrationRecord',
        name: 'registrationRecord',
        component: () => import('@/views/user/registrationRecord'),
        meta: { title: '报名记录' }
      },
      // 修改密码页
      {
        path: '/changePassword',
        name: 'changePassword',
        component: () => import('@/views/user/changePassword')
      },
      // 退出登录页
      {
        path: '/logOut',
        name: 'logOut',
        component: () => import('@/views/user/logOut'),
        meta: { title: '退出登录' }
      },
      // 通知页
      {
        path: '/inform',
        name: 'inform',
        component: () => import('@/views/inform/inform'),
        meta: { title: '通知', keepAlive: true }
      },
      // 通知详情页
      {
        path: '/informDetail',
        name: 'informDetail',
        component: () => import('@/views/inform/informDetail'),
        meta: { title: '通知详情' }
      },
      // 资讯页
      {
        path: '/information',
        name: 'information',
        component: () => import('@/views/information/information'),
        meta: { title: '资讯', keepAlive: true }
      },
      // 资讯详情页
      {
        path: '/informationDetail',
        name: 'informationDetail',
        component: () => import('@/views/information/informationDetail'),
        meta: { title: '资讯详情' }
      },
      // 海创大赛页
      {
        path: '/HCMegagame',
        name: 'HCMegagame',
        component: () => import('@/views/activity/HCMegagame'),
        meta: { title: '海创大赛' }
      },
      // 海创大赛详情页
      {
        path: '/HCMegagameDetail',
        name: 'HCMegagameDetail',
        component: () => import('@/views/activity/HCMegagameDetail'),
        meta: { title: '海创大赛' }
      },
      // 大赛获奖项目页
      {
        path: '/HCMegagameGetAwardProject',
        name: 'HCMegagameGetAwardProject',
        component: () => import('@/views/activity/HCMegagameGetAwardProject'),
        meta: { title: '海创大赛' }
      },
      // 获奖项目详情页
      {
        path: '/HCProjectDetails',
        name: 'HCProjectDetails',
        component: () => import('@/views/activity/HCProjectDetails'),
        meta: { title: '海创大赛' }
      },
      // 企业评选页
      {
        path: '/firmElect',
        name: 'firmElect',
        component: () => import('@/views/activity/firmElect'),
        meta: { title: '企业评选' }
      },
      // 企业评选详情页
      {
        path: '/firmElectDetail',
        name: 'firmElectDetail',
        component: () => import('@/views/activity/firmElectDetail'),
        meta: { title: '企业评选' }
      },
      // 企业发展报告页
      {
        path: '/firmDevelopmentReport',
        name: 'firmDevelopmentReport',
        component: () => import('@/views/activity/firmDevelopmentReport'),
        meta: { title: '企业评选' }
      },
      // 入选企业页
      {
        path: '/firmBeSelected',
        name: 'firmBeSelected',
        component: () => import('@/views/activity/firmBeSelected'),
        meta: { title: '企业评选' }
      },
      // 网络年会页
      {
        path: '/webAnnualMeeting',
        name: 'webAnnualMeeting',
        component: () => import('@/views/activity/webAnnualMeeting'),
        meta: { title: '网络年会' }
      },
      // 网络年会详情页
      {
        path: '/webAnnualMeetingDetail',
        name: 'webAnnualMeetingDetail',
        component: () => import('@/views/activity/webAnnualMeetingDetail'),
        meta: { title: '网络年会' }
      },
      // 其他活动页
      {
        path: '/elseActive',
        name: 'elseActive',
        component: () => import('@/views/activity/elseActive'),
        meta: { title: '其他活动', keepAlive: true }
      },
      // 基地页
      {
        path: '/basePage',
        name: 'basePage',
        component: () => import('@/views/base/basePage'),
        meta: { title: '基地', keepAlive: true }
      },
      // 基地发展报告与案例
      {
        path: '/reportCase',
        name: 'reportCase',
        component: () => import('@/views/base/reportCase'),
        meta: { title: '基地' }
      },
      // 园区页
      {
        path: '/garden',
        name: 'garden',
        component: () => import('@/views/garden/garden'),
        meta: { title: '园区', keepAlive: true }
      },
      // 园区详情页
      {
        path: '/gardenDetail',
        name: 'gardenDetail',
        component: () => import('@/views/garden/gardenDetail'),
        meta: { title: '园区' }
      },
      // 企业页
      {
        path: '/firm',
        name: 'firm',
        component: () => import('@/views/firm/firm'),
        meta: { title: '企业', keepAlive: true }
      },
      // 企业详情页
      {
        path: '/firmDetail',
        name: 'firmDetail',
        component: () => import('@/views/firm/firmDetail'),
        meta: { title: '企业详情' }
      },
      // 服务页
      {
        path: '/serve',
        name: 'serve',
        component: () => import('@/views/serve/serve'),
        meta: { title: '服务' }
      },
      // 政策页
      {
        path: '/policy',
        name: 'policy',
        component: () => import('@/views/policy/policy'),
        meta: { title: '政策', keepAlive: true }
      },
      // 政策详情页
      {
        path: '/policyDetail',
        name: 'policyDetail',
        component: () => import('@/views/policy/policyDetail'),
        meta: { title: '政策详情' }
      },
      // 杂志页
      {
        path: '/magazine',
        name: 'magazine',
        component: () => import('@/views/magazine/magazine'),
        meta: { title: '杂志' }
      },
      // 联盟服务体系页
      {
        path: '/serveSystem',
        name: 'serveSystem',
        component: () => import('@/views/league/serveSystem'),
        meta: { title: '联盟服务体系' }
      },
      // 联盟介绍页
      {
        path: '/leagueIntroduce',
        name: 'leagueIntroduce',
        component: () => import('@/views/league/leagueIntroduce'),
        meta: { title: '联盟介绍' }
      },
      // 联盟章程页
      {
        path: '/leagueRule',
        name: 'leagueRule',
        component: () => import('@/views/league/leagueRule'),
        meta: { title: '联盟章程' }
      },
      // 联盟组织机构页
      {
        path: '/organization',
        name: 'organization',
        component: () => import('@/views/league/organization'),
        meta: { title: '联盟组织机构' }
      },
      // 联盟发展历程页
      {
        path: '/development',
        name: 'development',
        component: () => import('@/views/league/development'),
        meta: { title: '联盟发展历程' }
      },
      {
        path: '/developmentDetatil',
        name: 'developmentDetatil',
        component: () => import('@/views/league/developmentDetatil'),
        meta: { title: '联盟发展历程' }
      },
      // 加入联盟
      {
        path: '/joinLeague',
        name: 'joinLeague',
        component: () => import('@/views/league/joinLeague'),
        meta: { title: '加入联盟' }
      }
    ]
  },

  // 园区后台管理系统首页
  {
    path: '/backstageIndex',
    // name: 'backstageIndex',
    component: () => import('@/views/gardenBackstage/backstageIndex'),
    children: [
      // 园区信息管理
      {
        path: '/',
        // name: 'situationInfo',
        component: () => import('@/views/gardenBackstage/gardenInfoManage/situationInfo'),
        meta: { title: '园区信息管理' }
      },
      {
        path: '/situationInfo',
        // name: 'situationInfo',
        component: () => import('@/views/gardenBackstage/gardenInfoManage/situationInfo'),
        children: [
          {
            path: '/',
            // name: 'surveyInfo',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/surveyInfo'),
            meta: { title: '园区信息管理' }
          },
          {
            // 概况信息
            path: '/surveyInfo',
            name: 'surveyInfo',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/surveyInfo'),
            meta: { title: '园区信息管理' }
          },
          {
            // 房源信息
            path: '/housingInfo',
            name: 'housingInfo',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/housingInfo'),
            meta: { title: '园区信息管理' }
          },
          // 招商信息
          {
            path: '/investmentInfo',
            name: 'investmentInfo',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/investmentInfo'),
            meta: { title: '园区信息管理' }
          },
          // 园区服务
          {
            path: '/gardenServe',
            name: 'gardenServe',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/gardenServe'),
            meta: { title: '园区信息管理' }
          },
          // 周边配套
          {
            path: '/surroundingFacility',
            name: 'surroundingFacility',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/surroundingFacility'),
            meta: { title: '园区信息管理' }
          },
          // 荣誉资质
          {
            path: '/honorAptitude',
            name: 'honorAptitude',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/honorAptitude'),
            meta: { title: '园区信息管理' }
          },
          // 数字园区
          {
            path: '/figureGarden',
            name: 'figureGarden',
            component: () => import('@/views/gardenBackstage/gardenInfoManage/figureGarden'),
            meta: { title: '园区信息管理' }
          }
        ]
      },
      // 企业信息管理
      {
        path: '/compantInfo',
        name: 'compantInfo',
        component: () => import('@/views/gardenBackstage/companyInfoManage/companyInfo'),
        meta: { title: '企业信息管理' }
      },
      {
        path: '/firmSituation',
        name: 'firmSituation',
        component: () => import('@/views/gardenBackstage/companyInfoManage/firmSituation'),
        meta: { title: '企业信息管理' }
      },
      // 提交基地年审
      {
        path: '/baseVerification',
        name: 'baseVerification',
        component: () => import('@/views/gardenBackstage/submitBaseVerification/baseVerification'),
        meta: { title: '提交基地年审' }
      }
    ]
  },
  // 404页面
  {
    path: '*',
    name: 'page404',
    component: () => import('@/views/page404/page404'),
    meta: { title: '404' }
  }

]
export default routes
